export function createBlobFromBytesArray(
  bytes: Iterable<number>,
  mimeType: string
) {
  const typedArray = new Uint8Array(bytes);
  return URL.createObjectURL(new Blob([typedArray.buffer], { type: mimeType }));
}
